import { createElement } from 'react';

export default (props, name) => {
  const { children, component, render, ...rest } = props;
  if (component) {
    return createElement(component, { ...rest, children, render });
  }
  if (render) {
    return render({ ...rest, children });
  }
  if (typeof children !== 'function') {
    console.error(
      'Form must specify either a render prop, a render function as children, or a component prop'
    );
    return null;
  }
  return children(rest);
};
